import { SpringConfig } from 'react-spring'

const configs = {
    normal: { tension: 180, friction: 26 },
    stiffer: { tension: 240, friction: 26 },
    stiff: { tension: 300, friction: 26 },
    stiffest: { tension: 500, friction: 26 }
}

export default configs
